import './Skills.css';
import { useEffect } from 'react';

function Skills({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const skillCategories = [
    {
      title: "Programming Languages",
      icon: "</>",
      skills: ["Python", "C++", "C", "JavaScript", "HTML/CSS", "Verilog", "VHDL", "MATLAB"]
    },
    {
      title: "Frameworks & Libraries",
      icon: "⚛️",
      skills: ["React.js", "Node.js", "Express.js", "Pandas", "Pygame", "OpenCV", "MediaPipe"]
    },
    {
      title: "Hardware & Embedded Systems",
      icon: "⚙️",
      skills: ["ESP32", "Arduino Uno / Nano", "Raspberry Pi", "FPGA Platforms", "Sensors & Actuators", "Motor Drivers"]
    },
    {
      title: "Tools & Software",
      icon: "🛠️",
      skills: ["Git/GitHub", "Firebase", "MySQL", "Quartus Prime", "Vivado", "KiCad", "Proteus", "AutoCAD", "Figma", "VS Code"]
    },
    {
      title: "Soft Skills",
      icon: "💡",
      skills: ["Problem Solving", "Team Leadership", "Technical Writing", "Critical Thinking", "Adaptability", "Time Management", "Effective Communication"]
    }
  ];

  return (
    <div className="skills-page">
      {/* ── Header ── (removed for global navbar) */}

      {/* ── Hero Strip ── */}
      <div className="skills-hero-strip">
        <div className="skills-strip-inner">
          <p className="skills-strip-label">Technical Toolkit</p>
          <h1 className="skills-strip-name">Skills & Technologies</h1>
          <p className="skills-strip-role">The languages, frameworks, and tools I use to build solutions.</p>
          <div className="hero-stats-row">
            <span className="hero-stat-pill">▸ 5 Skill Categories</span>
            <span className="hero-stat-pill">▸ 8 Programming Languages</span>
            <span className="hero-stat-pill">▸ Hardware & Software</span>
          </div>
          <div className="hero-watermark">⬢</div>
        </div>
      </div>

      {/* ── Main Content ── */}
      <main className="skills-main">
        <div className="skills-grid">
          {skillCategories.map((cat, idx) => (
            <div className="skills-card" key={idx}>
              <div className="skills-card-header">
                <span className="skills-icon">{cat.icon}</span>
                <h3 className="skills-title">{cat.title}</h3>
              </div>
              <div className="skills-tags">
                {cat.skills.map((skill, sIdx) => (
                  <span className="skills-tag" key={sIdx}>{skill}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* ── Footer ── */}
      <footer className="skills-footer">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="skills-footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>
    </div>
  );
}

export default Skills;
